import { createContext, ReactNode } from 'react';
import { useDevice } from 'app/agriculture/queries/devices/useDevice';
import { Device } from 'app/agriculture/queries/devices/types/Device';

interface DeviceDetailContextType {
    device: Device;
}

export const DeviceDetailContext = createContext<DeviceDetailContextType>(
    {} as DeviceDetailContextType,
);

export const DeviceDetailContextProvider = ({
    children,
    deviceId,
}: {
    children: ReactNode;
    deviceId: string;
}) => {
    const device = useDevice({ deviceId });
    return (
        <DeviceDetailContext.Provider value={{ device }}>{children}</DeviceDetailContext.Provider>
    );
};
